function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.28 11.609l5.304-5.304a2.75 2.75 0 014.064 3.697 5.483 5.483 0 011.611.285 4.252 4.252 0 00-6.736-5.042L5.22 10.548a.75.75 0 001.06 1.06zm2.829 4.95l.893-.894c.019.622.14 1.219.349 1.773l-.182.181A2.75 2.75 0 016.28 13.73l5.657-5.657a.75.75 0 111.06 1.06l-5.656 5.658a1.25 1.25 0 001.768 1.767z",
  fill: "#8F90A6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 15.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.354-1.854a.5.5 0 01.708 0l1.146 1.147 1.146-1.147a.5.5 0 01.708.708L16.207 15.5l1.147 1.146a.5.5 0 01-.708.708L15.5 16.207l-1.146 1.147a.5.5 0 01-.708-.708l1.147-1.146-1.147-1.146a.5.5 0 010-.708z",
  fill: "#8F90A6"
});

function SvgAttachDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgAttachDelete;